<div *ngIf="questionSets">
  <button
    #business_info_menu
    id="business_info_menu"
    class="menu-item"
    [class.inactive]="!isBusinessInfoMenuActive"
    [ngClass]="{ disabled: isCarrierPageEnabled }"
    (click)="setActiveMenuItem(business_info_menu.id)"
  >
    <div class="menu-space" [class.active]="showCheckMarkForBusinessInfo">
      <mat-icon role="img" class="mat-icon notranslate completed material-icons mat-icon-no-color">done</mat-icon>
    </div>
    <div class="menu-space">
      <span>Business info</span>
    </div>
  </button>
  <button
    #general_info_menu
    id="general_info_menu"
    class="menu-item"
    [class.inactive]="activeMenuOrder !== 4"
    [ngClass]="{ disabled: (isAppSyncedWithBP$ | async) === false || questionSets[3]?.answers.length === 0 || isCarrierPageEnabled }"
    [disabled]="(isAppSyncedWithBP$ | async) === false || questionSets[3]?.answers.length === 0"
    (click)="setActiveMenuItem(general_info_menu.id)"
  >
    <div class="menu-space" [class.active]="!showCheckMark(4)">
      <mat-icon role="img" class="mat-icon notranslate completed material-icons mat-icon-no-color">done</mat-icon>
    </div>
    <div class="menu-space">
      <span>General</span>
    </div>
  </button>
  <ng-container *ngFor="let queSet of questionSets">
    <div *ngIf="queSet.order === 5">
      <button
        id="{{ queSet.question_set.code }}"
        class="menu-item"
        [class.inactive]="activeQuestionSet?.question_set?.code !== queSet.question_set.code"
        [ngClass]="{ disabled: (isAppSyncedWithBP$ | async) === false || isCarrierPageEnabled }"
        [disabled]="(isAppSyncedWithBP$ | async) === false"
        (click)="setActiveMenuItem(queSet.question_set.code)"
      >
        <div class="menu-space" [class.active]="!showCheckMark(queSet.order, queSet.question_set.code)">
          <mat-icon role="img" class="mat-icon notranslate completed material-icons mat-icon-no-color">done </mat-icon>
        </div>
        <div class="menu-space">
          <span>{{ getMQSPageTitle(queSet.question_set.title, queSet.question_set.code) }}</span>
        </div>
      </button>
    </div>
    <div *ngIf="queSet.order > 5">
      <button
        id="{{ queSet.question_set.code }}"
        class="menu-item"
        [class.inactive]="activeQuestionSet?.question_set?.code !== queSet.question_set.code"
        [ngClass]="{ disabled: (isAppSyncedWithBP$ | async) === false || isCarrierPageEnabled }"
        [disabled]="(isAppSyncedWithBP$ | async) === false"
        (click)="setActiveMenuItem(queSet.question_set.code)"
      >
        <div class="menu-space" [class.active]="!showCheckMark(queSet.order, queSet.question_set.code)">
          <mat-icon role="img" class="mat-icon notranslate completed material-icons mat-icon-no-color">done </mat-icon>
        </div>
        <div class="menu-space">
          <span>{{ queSet.question_set.title }}</span>
        </div>
      </button>
    </div>
  </ng-container>
  <button
    *ngIf="isCarrierPageEnabled"
    #quote_info_menu
    id="quote_info_menu"
    class="menu-item"
    [ngClass]="activeMenuOrder === 0 ? 'active' : 'inactive'"
    (click)="setActiveMenuItem(quote_info_menu.id)"
  >
    <div class="menu-space">
      <p>({{ totalCarrierProducts }})</p>
    </div>
    <div class="menu-space">
      <span>Carrier Results</span>
    </div>
  </button>
</div>
